import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.banner-with-link-cards-images' ).each( ( key, element ) => {
        new Splide( element, {
          type: 'loop',
          perPage: 1,
          pagination: false,
          autoplay: true,
          interval: 3000,
        } ).mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'banner-with-link-cards', COMPONENT );
} )( app );
